// Login copy for an account that exists and the password matched, but the
// email is not verified yet. Anything else stays the generic credential error.
// No em dashes or en dashes in this copy.

export const ACCOUNT_INACTIVE_CODE = "account_inactive";
export const RESEND_COOLDOWN_SECONDS = 60;
export const INVALID_CREDENTIALS_MESSAGE = "Username or password is incorrect.";
export const RESEND_VERIFICATION_LABEL = "Resend verification email";
export const RESEND_VERIFICATION_SENT = "Verification email sent. Check your inbox.";
export const RESEND_VERIFICATION_LIMITED = "Too many resends for now. Try again in a little while.";
export const RESEND_VERIFICATION_FAILED = "Could not resend the verification email. Try again in a minute.";

export const verifyEmailLoginMessage = (email) => {
  const address = String(email || "").trim();
  if (!address) return "Please verify your email first. We sent a link to your inbox.";
  return `Please verify your email first. We sent a link to ${address}.`;
};

export const inactiveLoginFromResponse = (data, typedEmail = "") => {
  const code = String(data?.code || "").toLowerCase();
  // simplejwt uses no_active_account for wrong passwords too. Ignore it.
  if (code !== ACCOUNT_INACTIVE_CODE) return null;
  const email = String(data?.email || typedEmail || "").trim();
  return {
    code: ACCOUNT_INACTIVE_CODE,
    email,
    message: verifyEmailLoginMessage(email),
  };
};

// check_access sends this code with its 401 when a valid token belongs to an
// account whose email is not verified yet (the Google callback case).
export const isInactiveAccessError = (err) => {
  const status = Number(err?.response?.status || 0);
  const code = String(err?.response?.data?.code || "").toLowerCase();
  return status === 401 && code === ACCOUNT_INACTIVE_CODE;
};

export const cooldownSecondsLeft = (lastAttemptAt, now = Date.now()) => {
  const started = Number(lastAttemptAt || 0);
  if (!started) return 0;
  const leftMs = started + RESEND_COOLDOWN_SECONDS * 1000 - now;
  if (leftMs <= 0) return 0;
  return Math.ceil(leftMs / 1000);
};
